/// <amd-module name="VSS/Redux/Sagas/MeasureActions" />
import { AnyAction } from "redux";
import { effects } from "redux-saga";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export function* putAndMeasureAction(action: AnyAction) {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const performanceService: IVssPerformanceService = (yield effects.call([pageContext, pageContext.getService], "IVssPerformanceService")) as any;
    yield effects.call([performanceService, performanceService.addSplitTiming], `${action.type}.Start`);
    yield effects.put(action);
    yield effects.call([performanceService, performanceService.addSplitTiming], `${action.type}.End`);
}
